import React, { useCallback, useEffect, useState } from "react";
import OrderHeader from "shared/component/orderHeader/orderHeader";
import { formatDate } from "shared/helpers/utils";
import DxfGrid from "shared/component/dxf-grid/dxf-grid";

import ViewTicket from "./component/viewTicket";
import { bookingFilterAtom, useBookingSource } from "./my-booking.service";
import ActionsPanelComponent from "shared/component/dxf-grid/actions-panel.component";
import useModal from "shared/hooks/useModel";
import { client } from "shared/helpers/client";
import { downloadTicketBillPdf } from "shared/services/reportService";
import moment from 'moment';
import { usePreferences } from "customer/settings/preferences/preferences.service";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { Column, GroupItem, Summary } from "devextreme-react/data-grid";
import { useRecoilState } from "recoil";




const MyBooking = () => {
const {t} = useTranslation();
const [filter,setFilter] = useRecoilState(bookingFilterAtom)
const bookingSource = useBookingSource(filter)

const [totalItems, setTotalItems] = React.useState([
  {
    column: "netTotal",
    summaryType: "sum",
  },
]);
    const handleSortDate = useCallback(sortBy => {
        let start = moment(sortBy.from).format()
        let end = moment(sortBy.to).format()
        setFilter({filter:{"StartDate":{"operator":"Equals","value":start},"EndDate":{"operator":"Equals","value":end}}})   
    }, [setFilter]);

  return (
    <div className="myBooking">
      <div className="container">
        <OrderHeader title={t('my-booking.mainTitle')} handleSortDate={handleSortDate} />
        <div className="dataTable">
          <DxfGrid
            dataSource={bookingSource}
            colsSummery={['netTotal','issueDate']}
            columnChooser={{ enabled: true, mode: 'select', allowSearch: true }}
          >
            <Column dataField="paxName" caption={t('my-booking.name')} />
            <Column dataField="issueDate"  caption={t('my-booking.issue')} cellRender= {(data) => formatDate(data.value)} />
            <Column dataField="airLine" width='250' caption={ t('my-booking.airline')}  />
            <Column dataField="ticketNumber" caption={t('my-booking.ticket')} />
            <Column dataField="pnr" caption={t('my-booking.pnr')} />
            <Column dataField="status" caption={ t('my-booking.status')}  />
            <Column dataField="netTotal" width='250' caption={t('my-booking.total')}/>

            <Column dataField="gdsProvider"   caption={t('my-booking.gdsProvider',   { defaultValue: 'GDS Provider' })}   visible={false} />
            <Column dataField="direction"     caption={t('my-booking.direction',     { defaultValue: 'Direction' })}      visible={false} />
            <Column dataField="segment"       caption={t('my-booking.segment',       { defaultValue: 'Segment' })}        visible={false} />
            <Column dataField="basicFare"     caption={t('my-booking.basicFare',     { defaultValue: 'Basic Fare' })}     visible={false} />
            <Column dataField="ticketTaxes"   caption={t('my-booking.ticketTaxes',   { defaultValue: 'Ticket Taxes' })}   visible={false} />
            <Column dataField="ticketAmount"  caption={t('my-booking.ticketAmount',  { defaultValue: 'Ticket Amount' })}  visible={false} />
            <Column dataField="commision"     caption={t('my-booking.commision',     { defaultValue: 'Commision' })}      visible={false} />
            <Column dataField="commisionVAT"  caption={t('my-booking.commisionVAT',  { defaultValue: 'Commision VAT' })}  visible={false} />
            <Column dataField="airLineComm"   caption={t('my-booking.airLineComm',   { defaultValue: 'Airline Commission' })}     visible={false} />
            <Column dataField="airLineCommVAT" caption={t('my-booking.airLineCommVAT', { defaultValue: 'Airline Commission VAT' })} visible={false} />
            <Column dataField="routes"        caption={t('my-booking.routes',        { defaultValue: 'Routes' })}         visible={false} />
            <Column dataField="usercode"      caption={t('my-booking.usercode',      { defaultValue: 'User Code' })}      visible={false} />
            <Column dataField="passengerType" caption={t('my-booking.passengerType', { defaultValue: 'Passenger Type' })} visible={false} />
            <Column dataField="currency"      caption={t('my-booking.currency',      { defaultValue: 'Currency' })}       visible={false} />

            <Column   cellRender={(cell) => <UserActions cell={cell}  />} />
          </DxfGrid>

        </div>
      </div>
    </div>
  );
};
export function UserActions({ cell, component, rowIndex }) {
  const row = cell.data;
  const [viewTicket, openTicket, closeTicket] = useModal(false);
  const [ticket, setTicket] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);
  async function handleViewTicket(ticket) {
    openTicket();
    const { response } = await client("/OwnerBooking/GetTicketDetails", {
      params: { TicketNumber: row?.ticketNumber },
    });
    if (response) {
      setTicket(response);
    }
  }
  async function handlePrint() {
    setIsPrinting(true);
    await downloadTicketBillPdf(row?.id);
    setIsPrinting(false);
  }
  function getActions() {
    return [
      {
        label: "View Ticket",
        action: () => handleViewTicket(row),
      },
      { label: isPrinting ? "Printing..." : "Print", action: handlePrint },
      { label: "Send By E-mail", action: () => console.log(row) },
    ];
  }

  return (
    <>
      <ActionsPanelComponent actions={getActions()} />
      <ViewTicket ticketData={ticket} show={viewTicket} onHide={closeTicket} />
    </>
  );
}
export default MyBooking;
